// extracted by mini-css-extract-plugin
module.exports = {"pricing":"pricing_pricing__12Otz","price":"pricing_price__34v9z","dollar":"pricing_dollar__20OFc","amount":"pricing_amount__1NEaq","text":"pricing_text__1N0z3"};